export const TOTAL_IVA = 1.19;
export const TOTAL_CLIENT_COMISSION = 1;
export const TOTAL_TBK_COMISSION = 1.0304;
export const IVA = 0.19;
export const CLIENT_COMISSION = 0;
export const TBK_COMISSION = 0.0304;
export const COLLABORATOR_COMISSION = 0;
export const COLLABORATOR_RETENTION = 0.13;
